// Default state for the ecommerceItem object
export default () => ({
	name: null,
	variant: null,
	list_name: null,
	brand: "Breezeline Online",
	category: null,
	dimension1: null, // download speed
	dimension2: null, // channel count
	dimension3: null, // TV Added
	dimension4: null, // Voice Added
	dimension5: null, // Wifi Your Way Added
	dimension6: null, // Installation Date
	price: null,
	metric1: null, // full price
	quantity: 1
})